<template>
  <div @click="$emit('checked')" class="check-item" :class="{ checked: item.checked, short }">
    <div class="check"></div>
    <div class="info" v-html="item.info"></div>
  </div>
</template>

<script>
export default {
  name: 'CheckItem',
  props: {
    item: Object,
    short: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.check-item {
  @apply flex items-center justify-start w-full my-1 py-1;
  min-height: 42px;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
}
.checked {
  .check {
    background-image: url('../../../assets/MobileScan/checked.svg');
  }
  .info {
    font-weight: bold;
  }
  background: #E1E5FF;
}
.short {
  @apply my-0 py-0;
  .check {
    height: 30px;
  }
}
.check {
  @apply px-2;
  background-image: url('../../../assets/MobileScan/unchecked.svg');
  background-repeat: no-repeat;
  min-width: 50px;
  min-height: 48px;
  background-position: left;
  background-position-x: 20px;
}
.info {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: #555555;
}
</style>
